export const SearchOptions = `
<rect width="1024" height="142.222" />
<rect y="355.556" width="658.286" height="142.222" />
<rect y="711.111" width="292.571" height="142.222" />
`;





// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/icons/search-options.js